import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigService, StoreService } from 'app/services';
import { Utils } from 'app/utils';

@Component({
    selector: 'partner-mart-locations-group-details',
    templateUrl: './partner-mart-locations-group-details.component.html',
    styleUrls: [
        './partner-mart-locations-group-details.component.scss',
        '../../partner-mart-locations-root/partner-mart-locations-root.component.scss'
    ],
    providers: [MessageService]
})
export class PartnerMartLocationsGroupDetailsComponent implements OnInit, OnDestroy {
    @Input()
    public groupId: number = 0;

    public group: any = {};

    public isEditGroupPopupVisible: boolean = false;

    private map!: google.maps.Map;
    private zoomChangedListener: google.maps.MapsEventListener | undefined = undefined;
    private groupPolygon: google.maps.Polygon | undefined = undefined;
    private groupCircle: google.maps.Circle | undefined = undefined;

    constructor(
        private messageService: MessageService,
        public configService: ConfigService,
        private storeService: StoreService) {
        this.onEditGroupPopupSave = this.onEditGroupPopupSave.bind(this);
        this.onEditGroupPopupHide = this.onEditGroupPopupHide.bind(this);
    }

    ngOnInit(): void {
        this.getGroup();
    }

    ngOnDestroy() {
        if (this.zoomChangedListener) {
            google.maps.event.removeListener(this.zoomChangedListener);
        }
    }

    private getGroup(): void {
        const dto = {
            GroupId: this.groupId
        };

        this.storeService.getStoreGroupForEdit(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.group = data;

                this.initMap();
            });
    }

    // Init map
    private initMap(): void {
        const options = Object.assign({}, Utils.getDefaultMapOptions(), {
            mapTypeControl: false, // Remove "map satellite" and other options
            zoomControl: false,
            streetViewControl: false
        });

        // Create map
        if (!this.map) {
            this.map = new google.maps.Map(document.getElementById('groupDetailsMap') as HTMLElement, options);

            // Zoom changed
            this.zoomChangedListener = google.maps.event.addListener(this.map, 'zoom_changed', () => {
                // Redraw locations
                //this.showStoresOnMap();
            });
        }

        // Show group on map
        this.showGroupOnMap();

        // Show group stores on map
        //this.showStoresOnMap();
    }

    // Show group on map
    private showGroupOnMap(): void {
        if (this.groupPolygon) {
            this.groupPolygon.setMap(null);
            this.groupPolygon = undefined;
        }

        if (this.groupCircle) {
            this.groupCircle.setMap(null);
            this.groupCircle = undefined;
        }

        // If group is polygon
        if (this.group.Polygon) {
            const bounds = new google.maps.LatLngBounds();
            const polygonCoords: any[] = [];

            for (const polygon of this.group.Polygon) {
                bounds.extend(new google.maps.LatLng(polygon.Lat, polygon.Lng));
                polygonCoords.push({ lat: polygon.Lat, lng: polygon.Lng });
            }

            this.groupPolygon = new google.maps.Polygon({
                paths: polygonCoords,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
            });

            this.groupPolygon.setMap(this.map);

            // Fit group on map
            this.map.fitBounds(bounds);
        }
        // If group is circle
        else if (this.group.Circle) {
            this.groupCircle = new google.maps.Circle({
                radius: this.group.Circle.Radius,
                center: { lat: this.group.Circle.Lat, lng: this.group.Circle.Lng },
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2
            });

            this.groupCircle.setMap(this.map);

            // Fit group on map
            const bounds = this.groupCircle.getBounds();

            if (bounds) {
                this.map.fitBounds(bounds);
            }
        }
    }

    public onEditClick(): void {
        this.isEditGroupPopupVisible = true;
    }

    public onEditGroupPopupSave(): void {
        this.getGroup();

        this.isEditGroupPopupVisible = false;

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully saved' });
    }

    public onEditGroupPopupHide(): void {
        this.isEditGroupPopupVisible = false;
    }
}
